import { useState, useEffect } from "react";
import PillButton from "components/General/PillButton";
export default function GameIdButton({
  gameId,
}: {
  gameId: string
}) {
  const [displayText, setDisplayText] = useState(gameId);

  useEffect(() => {
    if (gameId) {
      setDisplayText(gameId);
    } else {
      setDisplayText("...");
    }
  }, [gameId])

  return (
    <PillButton
      text={displayText}
      onClick={() => {
        const textarea = document.createElement('textarea');
        textarea.value = gameId;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy'); // Fallback for copying text
        document.body.removeChild(textarea);
          // alert('Text copied to clipboard!');

        setDisplayText("Copied!!!");

        setTimeout(() => {
          setDisplayText(gameId);
        }, 1000)
      }}
    />
  )
}
